<template>
  <div id="report">
    <div class="full-overlay">
      <div class="overlay-header">
        <!-- Nav -->
        <b-container fluid>
          <b-row align-h="center" align-v="center" class="my-md-4">
            <b-col></b-col>
            <b-col cols="7">
              <div class="overlay-subnav text-center" v-if="$route.name != 'Results'">
                <b-button class="icon--color" style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) === 0" variant="link"  :to="availableReports[availableReports.indexOf(openedReport)-1]"><icon scale="2" name="angle-left"/></b-button>
                <span class="subnav-progress">
                  <router-link class="item" :key="index" v-for="(report, index) in availableReports" :class="{'active': report === openedReport}" :to="report"></router-link>
                </span>
                <b-button class="icon--color" style="vertical-align: top;" :disabled="availableReports.indexOf(openedReport) >= availableReports.length -1" variant="link" :to="availableReports[availableReports.indexOf(openedReport)+1]"><icon scale="2" name="angle-right"/></b-button>
              </div>
            </b-col>
            <b-col class="text-right">
              <b-button class="icon--color" variant="link" :to="closePath" id="close-button"><icon name="times" scale="2"/></b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="overlay-content">
        <b-container fluid class="px-0 pt-0 pb-4">
          <b-row align-v="center" align-h="center" class="py-4 mb-5 card--text">
            <b-col cols="12" sm="12" md="10" class="text-center p-3">
              <slot name="header"/>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid class="pt-0 pb-5">
          <slot />
        </b-container>
      </div>
      <div class="overlay-footer d-none d-md-block">
        <b-container fluid>
          <b-row align-h="center">
            <b-col class="text-center mt-3 mb-3 my-md-4">
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['availableReports', 'closePath', 'openedReport']
}
</script>
<style lang="scss">
.card--text {
  color: var(--white);
  background-color: #ff8e72;
}
.icon--color {
  color: #ff8e72;
}
.icon--color:hover {
  color: #ed6a5e;
}
.overlay-subnav > .icon--color:disabled {
  color: #ed6a5e;
  opacity: .5;
}
</style>
